exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 300;\n  font-style: normal;\n  letter-spacing: normal;\n  font-size: 16px;\n  color: #9c9c9c;\n  line-height: 1.3em;\n  margin-bottom: 1em;\n}\np a {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 300;\n  font-style: normal;\n  font-stretch: normal;\n  font-size: 16px;\n  color: #9c9c9c;\n}\np a {\n  color: #32b4e5;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/oss/oss.component.less
// module id = 359
// module chunks = 0